import React from "react";
import Grid from "@material-ui/core/Grid";
import { useRptAF } from "../../../../St/Reviews/UseStyle";
import MaterialTable from "material-table";
import { stElemnt } from "../../../../St/Reviews/cStyle";
import { colors} from "@material-ui/core";
import { styleNo } from "../../../Invs/ShareFunctionsPrint";
import { useTranslation } from "react-i18next";
import { reFormatDate } from "../../../../utils/utils";

export function TotalsTrans({infData}) {
  const cls = useRptAF();
  return (
    <Grid
      container
      lg={12}
      md={12}
      className={cls.rootBdydown}
      style={{ paddingBottom: 5, backgroundColor: colors.grey[100], fontFamily: "Amiri-Regular" }}
    >
      <Grid container xs={12} /*className={cls.rootchip}*/ style={{
        paddingBottom: 5,
        backgroundColor: colors.grey[100], fontFamily: "Amiri-Regular",
        border: "solid 1px",
        padding: "0.3rem 0.1rem 0.3rem 0.1rem",
        borderRadius: "0px 0px 5px 0px"
      }}>
        { infData?.kind==5 ? (
          <Grid container xs={12} >
            <Grid item xs={2} className={[cls.chipVMU]}>
              {"عدد السجلات"}
            </Grid>
            <Grid item xs={1} className={[cls.chipVMU]}>
              {infData.tot.countRow}
            </Grid>
            <Grid item xs={2} className={[cls.chipVMU]}>
              {"إجمالي الرصيد للفترة"}
            </Grid>
            <Grid item xs={1} className={[cls.chipVMU]}>
              {infData.tot.totSal}
            </Grid>
          </Grid>
        ):
        infData.showPrice ? (
          <Grid container xs={12} >
            <Grid item xs={2} className={[cls.chipVMU]}>
              {"عدد الأصناف"}
            </Grid>
            <Grid item xs={1} className={[cls.chipVMU]}>
              {infData.tot.count}
            </Grid>
            <Grid item xs={2} className={[cls.chipVMU]}>
              {"إجمالي الكميات"}
            </Grid>
            <Grid item xs={1} className={[cls.chipVMU]}>
              {infData.tot.totQun}
            </Grid>

            <Grid item xs={2} className={[cls.chipVMU]}>
              {"إجمالي الكلي للكميات"}
            </Grid>
            <Grid item xs={1} className={[cls.chipVMU]}>
              {infData.tot.totCost}
            </Grid>
            <Grid item xs={2} className={[cls.chipVMU]}>
              {" اجمالي المبلغ"}
            </Grid>
            <Grid item xs={1} className={[cls.chipVMU]}>
              {infData.tot.totPrice}
            </Grid>
          </Grid>
        ) :
        (
          <Grid container xs={12} >
            <Grid item xs={2} className={[cls.chipVMU]}>
              {"عدد الأصناف"}
            </Grid>
            <Grid item xs={2} className={[cls.chipVMU]}>
              {infData.tot.count}
            </Grid>
            <Grid item xs={2} className={[cls.chipVMU]}>
              {"إجمالي الكميات"}
            </Grid>
            <Grid item xs={2} className={[cls.chipVMU]}>
              {infData.tot.totQun}
            </Grid>

            <Grid item xs={2} className={[cls.chipVMU]}>
              {"إجمالي الكلي للكميات"}
            </Grid>
            <Grid item xs={2} className={[cls.chipVMU]}>
              {infData.tot.totCost}
            </Grid>

          </Grid>


        )

        }
      </Grid>

    </Grid>
  );
}
function BodyTransfer({ data, isLast,infData }) {
  const cls = useRptAF();
  const { t } = useTranslation(["forms"]);

  const cellS = {
    padding: "0px 0px",
    textAlign: "-webkit-center",
    margin: "0px",
    whiteSpace: "normal",
    border: "solid 0.1px",
    fontSize: "14px",
    width: "32%",
    fontFamily: "Amiri-Regular",
    fontWeight: "bold",
  };
  var columns = [
    { title: "م", field: "no" ,cellStyle:styleNo},
    { title: "الباركود", field: "barcode" },
    { title: "الصنف", field: "symbol",cellStyle:cellS },
    { title: "الوحدة", field: "unitName" },
    { title: "الكمية", field: "val1" },
    { title: "الكمية الاجمالية", field: "value" },
  ];
  var columnsP = [
    { title: "م", field: "no" ,cellStyle:styleNo},
    { title: "الباركود", field: "barcode" },
    { title: "الصنف", field: "symbol",cellStyle:cellS },
    { title: "الوحدة", field: "unitName" },
    { title: "الكمية", field: "val1" },
    { title: " السعر", field: "price" },
    { title: "الاجمالي", field: "total" },
  ];

  var columnsMov = [
    { title: t("movement_type"), field: "Name_Trans" },
    // { title: t("safe"), field: "Name_Safe" },
    { title:t("invoice-id"), field: "id" ,cellStyle:styleNo},
    // { title: t("date"), field: "date" },
    {
      title:t("date"), field: "date",
      render: (expense) => reFormatDate(expense.date)
    },
    { title: t("quanity"), field: "val" },
    { title: t("price"), field: "exchange_price" },
    { title:t("total"), field: "total" },
    { title:t("note"), field: "Name_Customer",cellStyle:cellS },
  ];


  const data2 = data.map((row, i) => {
    return {
      ...row,
      total: parseFloat(row.total).toFixed(2),
    };
  });
  return (
    <Grid item container className={cls.rootBdy}>
      <Grid item container className={cls.rootBdyup}  >
        <Grid
          item
          xs={12}
        >
          <MaterialTable
            style={{ boxShadow: "none" ,width:"100%",tableLayout:"fixed"}}
            options={{
              showTitle: false,
              toolbar: false,
              sorting: false,
              selection: false,
              // ToolBar Search
              searchFieldAlignment: "left",
              searchFieldVariant: "outlined",
              // ToolBar header
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              pageSize: 5,
              paginationType: "stepped",
              showFirstLastPageButtons: false,

              headerStyle: {
                ...stElemnt.AF.header,
                backgroundColor: colors.grey[100],
                fontWeight: "bold",
                paddingTop: "2px",
                paddingBottom: "2px",
                border: "solid 0px",
                border: "solid 0.1px",


              },
              paging: false,
              cellStyle: {
                ...stElemnt.AF.cell,
                padding: "0px 1px",
                // fontSize: 8,
              },
            }}
            localization={{
              body: {
                emptyDataSourceMessage: (
                  <h5 style={{ color: "GrayText" }}>
                    لا توجد ارصدة بعد في هذا الحساب
                  </h5>
                ),
              },
            }}
            columns={infData.kind == 5 ?columnsMov:   infData.showPrice ? columnsP : columns}
            data={data2}
          />
          {isLast && <TotalsTrans infData={infData} />}
        </Grid>

      </Grid>


    </Grid>
  );
}

export default BodyTransfer;
